import React from 'react';

const InputField = ({ label, name, value, onChange, type = "text", placeholder="" }) => (
    <div className="form-group mb-4">
        <label className="form-label">{label}</label>
        <input
            type={type}
            name={name}
            className="form-control input_text rounded-0"
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
        />
    </div>
);

export default InputField;
